import { createContext, useContext, useMemo, useState, type ReactNode } from "react";
import type { AdminRouteMeta } from "../lib/adminRouteMeta.js";

type AdminPageMetaContextValue = {
  override: AdminRouteMeta | null;
  setOverride: (meta: AdminRouteMeta | null) => void;
};

const AdminPageMetaContext = createContext<AdminPageMetaContextValue | null>(null);

export const AdminPageMetaProvider = ({ children }: { children: ReactNode }) => {
  const [override, setOverride] = useState<AdminRouteMeta | null>(null);
  const value = useMemo(() => ({ override, setOverride }), [override]);
  return <AdminPageMetaContext.Provider value={value}>{children}</AdminPageMetaContext.Provider>;
};

export const useAdminPageMetaContext = () => {
  const ctx = useContext(AdminPageMetaContext);
  if (ctx === null) {
    throw new Error("useAdminPageMetaContext must be used within AdminPageMetaProvider");
  }
  return ctx;
};
